module.exports = __webpack_public_path__ + "img/military-helmet.8aadb927.png";